import { Subject } from 'rxjs'
import { Injectable } from '@tanbo/di'

@Injectable()
export class CaptchaCheckService {
  /** 显示状态改变发布者 */
  onChangeVisible = new Subject<boolean>()

  /** 是否展示验证码弹窗 */
  private visible = false
  /**  验证码key */
  captchaId = ''
  /**  验证码号码 */
  captchaCode = ''

  /** 校验不通过 */
  checkReject: (value: unknown) => void = () => ({})
  /** 校验通过 */
  checkResolve: (value: unknown) => void = () => ({})

  /** 发起验证码校验 */
  check () {
    this.changeVisible(true)
    return new Promise((resolve, reject) => {
      this.checkResolve = resolve
      this.checkReject = reject
    })
  }

  setCaptchaId (key: string) {
    this.captchaId = key
  }

  /** 关闭 */
  close () {
    this.changeVisible(false)
  }

  /** 显示状态改变 统一入口 */
  changeVisible (visible: boolean) {
    this.visible = visible
    this.onChangeVisible.next(visible)
  }
}
